import React, { useState } from 'react';
import { Star, Heart, MessageSquare, CheckCircle2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const ALL_REVIEWS = [{
  user: '@lucia_reiki_88',
  text: 'Increíble el material, ya estoy usando las fichas editables.',
  likes: 12,
  time: '2 horas'
}, {
  user: '@marcos_holistico',
  text: 'El protocolo de manifestación es lo que me faltaba. Gracias!',
  likes: 8,
  time: '4 horas'
}, {
  user: '@ana_sanacion',
  text: 'Muy completo todo, las imágenes de los chakras están bárbaras.',
  likes: 15,
  time: '6 horas'
}, {
  user: '@terapeuta_luz',
  text: 'Las meditaciones son de otro planeta. Mis pacientes lo notan.',
  likes: 21,
  time: '8 horas'
}, {
  user: '@reiki_master_arg',
  text: 'Por fin algo profesional y bien organizado. Vale cada centavo.',
  likes: 34,
  time: '12 horas'
}, {
  user: '@sofi_energia',
  text: 'El mapa de bloqueos me voló la cabeza. Muy recomendado.',
  likes: 19,
  time: '1 día'
}, {
  user: '@pablo_zen',
  text: 'Excelente soporte y el material es de primera calidad.',
  likes: 7,
  time: '1 día'
}, {
  user: '@caro_holistica',
  text: 'Me sirvió mucho para mis clases de yoga también.',
  likes: 11,
  time: '2 días'
}, {
  user: '@espacio_alma',
  text: 'Las fichas de Canva son súper fáciles de editar. Muy práctico.',
  likes: 25,
  time: '2 días'
}, {
  user: '@juan_reiki',
  text: 'Un antes y un después en mi práctica profesional.',
  likes: 42,
  time: '3 días'
}, {
  user: '@marta_sanadora',
  text: 'Lo compré ayer y ya devoré la mitad del material. Genial!',
  likes: 14,
  time: '3 días'
}, {
  user: '@vibrando_alto',
  text: 'La protección energética es clave, me cambió la vida.',
  likes: 28,
  time: '4 días'
}, {
  user: '@luz_interior',
  text: 'Muy agradecida por compartir este conocimiento tan valioso.',
  likes: 16,
  time: '4 días'
}, {
  user: '@terapias_bsas',
  text: 'El kit más completo que vi en mucho tiempo. Felicitaciones!',
  likes: 31,
  time: '5 días'
}, {
  user: '@ser_consciente',
  text: 'Las guías de post-sesión son un plus increíble.',
  likes: 9,
  time: '5 días'
}, {
  user: '@reiki_flow',
  text: 'Mis sesiones ahora tienen una estructura mucho más clara.',
  likes: 22,
  time: '6 días'
}, {
  user: '@alma_libre',
  text: 'Recomendado para todos los niveles de Reiki.',
  likes: 18,
  time: '6 días'
}, {
  user: '@paz_mental',
  text: 'El precio es un regalo para todo lo que trae.',
  likes: 53,
  time: '1 semana'
}, {
  user: '@energia_vital',
  text: 'Me encantaron los protocolos de diagnóstico.',
  likes: 13,
  time: '1 semana'
}, {
  user: '@terapeuta_online',
  text: 'Ideal para quienes trabajamos a distancia también.',
  likes: 27,
  time: '1 semana'
}, {
  user: '@reiki_luz_vida',
  text: 'Las visualizaciones son muy potentes. Gracias!',
  likes: 20,
  time: '1 semana'
}, {
  user: '@sanacion_cuantica',
  text: 'Un material indispensable para cualquier terapeuta.',
  likes: 35,
  time: '2 semanas'
}, {
  user: '@yoga_reiki_paz',
  text: 'Muy bien explicado y fácil de aplicar.',
  likes: 17,
  time: '2 semanas'
}, {
  user: '@maestra_reiki',
  text: 'Lo uso con mis alumnos y les encanta.',
  likes: 48,
  time: '2 semanas'
}, {
  user: '@vibras_positivas',
  text: 'El diseño de los materiales es hermoso.',
  likes: 12,
  time: '3 semanas'
}, {
  user: '@centro_holistico',
  text: 'Nos ahorró meses de trabajo en formularios.',
  likes: 39,
  time: '3 semanas'
}, {
  user: '@reiki_terapeutico',
  text: 'La mejor inversión que hice este año.',
  likes: 61,
  time: '1 mes'
}, {
  user: '@luz_y_amor',
  text: 'Gracias por este kit tan maravilloso.',
  likes: 15,
  time: '1 mes'
}, {
  user: '@terapeuta_integral',
  text: 'Muy profesional y con mucha alma.',
  likes: 24,
  time: '1 mes'
}, {
  user: '@reiki_master_pro',
  text: 'Superó mis expectativas por completo.',
  likes: 45,
  time: '1 mes'
}, {
  user: '@energia_pura',
  text: 'Un material que todo reikiista debería tener.',
  likes: 19,
  time: '1 mes'
}, {
  user: '@sanar_desde_adentro',
  text: 'Muy completo y fácil de entender.',
  likes: 22,
  time: '2 meses'
}, {
  user: '@reiki_argentina',
  text: 'Excelente relación calidad-precio.',
  likes: 33,
  time: '2 meses'
}];
export function Reviews() {
  const [comment, setComment] = useState('');
  const [rating, setRating] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [visibleCount, setVisibleCount] = useState(3);
  const handlePublish = () => {
    if (comment.trim()) {
      setShowPopup(true);
      setComment('');
      setRating(0);
    }
  };
  const loadMore = () => {
    setVisibleCount(prev => Math.min(prev + 5, ALL_REVIEWS.length));
  };
  return <section className="py-20 bg-violet-50 pt-[30px] pb-[30px]" data-id="element-356">
      <div className="max-w-3xl mx-auto px-4" data-id="element-357">
        <h2 className="text-violet-950 mb-10 text-center text-[32px] md:text-[48px] font-medium font-['Playfair_Display']" data-id="element-358">
          Comunidad Reiki
        </h2>

        <div className="bg-white p-6 rounded-2xl border border-violet-100 mb-12 shadow-sm" data-id="element-359">
          <h3 className="text-violet-950 font-bold mb-4" data-id="element-360">
            Deja tu reseña para la comunidad:
          </h3>
          <textarea value={comment} onChange={e => setComment(e.target.value)} placeholder="Escribe aquí tu experiencia con el Kit..." className="w-full bg-violet-50 border border-violet-100 rounded-xl p-4 text-violet-950 focus:border-violet-400 outline-none transition-colors mb-4 min-h-[100px]" data-id="element-361" />
          <div className="flex flex-wrap items-center justify-between gap-4" data-id="element-362">
            <div className="flex items-center gap-2" data-id="element-363">
              <span className="text-violet-400 text-sm" data-id="element-364">Calificar:</span>
              <div className="flex gap-1" data-id="element-365">
                {[1, 2, 3, 4, 5].map(s => <button key={s} onClick={() => setRating(s)} className={`${rating >= s ? 'text-violet-600' : 'text-violet-200'} hover:scale-110 transition-transform`} data-id="element-366">
                    <Star size={20} fill={rating >= s ? 'currentColor' : 'none'} data-id="element-367" />
                  </button>)}
              </div>
            </div>
            <button onClick={handlePublish} className="bg-violet-950 text-white font-black px-8 py-3 rounded-full hover:bg-violet-800 transition-colors uppercase text-sm" data-id="element-368">
              Publicar
            </button>
          </div>
        </div>

        <div className="space-y-8" data-id="element-369">
          {ALL_REVIEWS.slice(0, visibleCount).map((rev, i) => <div key={i} className="border-b border-violet-100 pb-6" data-id="element-370">
              <div className="flex items-center justify-between mb-2" data-id="element-371">
                <span className="text-violet-600 font-bold text-sm" data-id="element-372">
                  {rev.user}
                </span>
                <div className="flex text-violet-600" data-id="element-373">
                  {[...Array(5)].map((_, i) => <Star key={i} size={12} fill="currentColor" data-id="element-374" />)}
                </div>
              </div>
              <p className="text-violet-900 mb-3" data-id="element-375">{rev.text}</p>
              <div className="flex items-center gap-4 text-xs text-violet-400" data-id="element-376">
                <button className="flex items-center gap-1 hover:text-violet-600 transition-colors" data-id="element-377">
                  <Heart size={14} data-id="element-378" /> {rev.likes} Likes
                </button>
                <span data-id="element-379">hace {rev.time}</span>
              </div>
            </div>)}
          {visibleCount < ALL_REVIEWS.length && <button onClick={loadMore} className="w-full py-4 text-violet-400 font-bold hover:text-violet-600 transition-colors uppercase text-sm tracking-widest" data-id="element-380">
              Cargar 5 comentarios más
            </button>}
        </div>
      </div>

      <AnimatePresence data-id="element-381">
        {showPopup && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-violet-950/40 backdrop-blur-sm" data-id="element-382">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} className="bg-white border-2 border-violet-600 p-8 rounded-3xl max-w-sm w-full text-center shadow-2xl" data-id="element-383">
              <div className="w-16 h-16 bg-violet-600 rounded-full flex items-center justify-center mx-auto mb-4 text-white" data-id="element-384">
                <CheckCircle2 size={32} data-id="element-385" />
              </div>
              <h4 className="text-xl font-black text-violet-950 mb-2" data-id="element-386">
                ¡Gracias por tu comentario!
              </h4>
              <p className="text-violet-800/60 mb-6" data-id="element-387">
                Tu opinión ayuda a la comunidad.
              </p>
              <button onClick={() => setShowPopup(false)} className="w-full bg-violet-950 text-white font-black py-3 rounded-xl uppercase text-sm" data-id="element-388">
                Cerrar
              </button>
            </motion.div>
          </div>}
      </AnimatePresence>
    </section>;
}